import { RootState } from '@store/redux.store'
import type { TaskTrackerState } from '../index'

type AppState = RootState & {
  taskTracker: TaskTrackerState
}

export const selectTaskTrackerSidebarCollapsed = (state: AppState) =>
  state.taskTracker.sidebar.collapsed
